export const mapSubRouteConfigToMenuItemData = (config) => {
    const subRoutes = config.subRoutes;
    const menuItems = [];
    for (const subRoute in subRoutes) {
        const route = subRoutes[subRoute];
        if (route && route.menuTitle) {
            const title = route.menuTitle;
            const path = route.path;
            menuItems.push({
                title: title,
                path: path,
            });
        }
    }
    return menuItems;
};
